import { cn } from '@/src/lib/utils';

interface ProgressBarProps {
    steps: {
        id: string;
        name: string;
        status: string;
    }[];
    setStep: (step: string) => void;
}

export default function ProgressBar({ steps, setStep }: ProgressBarProps) {
    return (
        <nav aria-label="Progress ">
            <ol className="space-y-4 md:flex md:space-x-8 md:space-y-0 hidden md:block">
                {steps.map((step) => (
                    <li
                        key={step.name}
                        className={cn(
                            step.status === 'complete' && 'cursor-pointer',
                            'md:flex-1',
                        )}
                    >
                        {step.status === 'complete' ? (
                            // eslint-disable-next-line
                            <a
                                className="group flex flex-col border-dark dark:border-gray-100 hover:border-gray-900 dark:hover:border-gray-100 border-l-0 border-t-4 pb-0 pl-0 pt-4 cursor-pointer"
                                onClick={() => setStep(step.id)}
                            >
                                <span className="text-sm font-medium text-[#333333] dark:text-[#ffffff] group-hover:text-[#333333] dark:group-hover:text-[#ffffff] cursor-pointer">
                                    {step.id}
                                </span>
                                <span className="text-sm font-medium monospace-font text-black dark:text-white cursor-pointer">
                                    {step.name}
                                </span>
                            </a>
                        ) : step.status === 'current' ? (
                            // eslint-disable-next-line
                            <a
                                aria-current="step"
                                className="flex flex-col border-dark dark:border-gray-100 border-l-0 border-t-4 pb-0 pl-0 pt-4"
                            >
                                <span className="text-sm font-medium text-black dark:text-white">
                                    {step.id}
                                </span>
                                <span className="text-sm font-medium monospace-font text-black dark:text-white">
                                    {step.name}
                                </span>
                            </a>
                        ) : (
                            // eslint-disable-next-line
                            <a
                                className="group flex flex-col border-subdued dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 border-l-0 border-t-4 pb-0 pl-0 pt-4"
                                onClick={() => setStep(step.id)}
                            >
                                <span className="text-sm font-medium text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-600">
                                    {step.id}
                                </span>
                                <span className="text-sm font-medium monospace-font text-black dark:text-white">
                                    {step.name}
                                </span>
                            </a>
                        )}
                    </li>
                ))}
            </ol>
            <div className="block md:hidden flex flex-row">
                {/*<div className="flex justify-between">
                    <div className="flex items-center">
                        <span className="text-sm font-medium monospace-font text-black dark:text-white">
                            {steps[0].name}
                        </span>
                    </div>
                    <span className="text-sm font-medium monospace-font text-gray-500 dark:text-gray-400">
                        Step{' '}
                        {steps.findIndex((step) => step.status === 'current') +
                            1}{' '}
                        of {steps.length}
                    </span>
                </div>*/}
                {steps.map((step, index) => {
                    return (
                        <>
                            {index > 0 && (
                                <div className="pl-[0px] w-10 text-center">
                                    /
                                </div>
                            )}
                            <div>
                                {step.status === 'complete' ? (
                                    // eslint-disable-next-line
                                    <a onClick={() => setStep(step.id)}>
                                        <span className="text-xs font-medium monospace-font text-black dark:text-white cursor-pointer">
                                            {step.name}
                                        </span>
                                    </a>
                                ) : step.status === 'current' ? (
                                    // eslint-disable-next-line
                                    <a aria-current="step">
                                        <span className="text-xs font-medium monospace-font text-black dark:text-white">
                                            {step.name}
                                        </span>
                                    </a>
                                ) : (
                                    // eslint-disable-next-line
                                    <a>
                                        <span className="text-xs font-medium monospace-font text-gray-500 dark:text-gray-400">
                                            {step.name}
                                        </span>
                                    </a>
                                )}
                            </div>
                        </>
                    );
                })}
            </div>
        </nav>
    );
}
